import {
  extendObservable,
  observable,
  action,
  reaction,
  autorun,
  computed,
} from 'mobx';

// state aus ["toRequest", "notSetUpYet", "success", "error", "busy",  ]

class SingleRequestStore {
  constructor({ defaultVal, onDemandRequest } = {}) {
    this.onDemandRequest = onDemandRequest;
    extendObservable(
      this,
      {
        state: 'nothing', // "toRequest" "success" "error" "loading"
        message: '',
        defaultVal,
        requestedValue: undefined,
        valCompution: (val, history) => val,
        history: [],
        get value() {
          if (this.onDemandRequest && this.state === 'nothing')
            this.setState('toRequest');
          return this.valCompution(
            this.requestedValue ? this.requestedValue : this.defaultVal,
            this.history,
          );
        },
        setState: this.setState,
        setMessage: this.setMessage,
        setValue: this.setValue,
        addToHistory: this.addToHistory,
        clearHistory: this.clearHistory,
        setValCompution: this.setValCompution,
      },
      {
        state: observable,
        message: observable,
        defaultVal: observable,
        valCompution: observable,
        requestedValue: observable,
        history: observable,
        addToHistory: action,
        clearHistory: action,
        setValCompution: action,
        value: computed,
        setState: action,
        setValue: action,
        setMessage: action,
      },
    );
  }

  setState(state) {
    this.state = state;
  }

  setValue(value) {
    this.requestedValue = value;
  }

  setMessage(message) {
    this.message = message;
  }

  setValCompution(setFun) {
    this.valCompution = setFun;
  }

  addToHistory(config) {
    this.history.push(config);
  } // evtl ist ne deep copy hier erforderlich, da ansonsten evtl nru referenziert => problematisch

  clearHistory() {
    this.history = [];
  }
}
export default SingleRequestStore;
